// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1CIVR","subheader":"ReorderModal_subheader__3GBwM","listWrap":"ReorderModal_listWrap__uBJNv"};